import { BaseFieldRenderer } from './base-field-renderer';
import { TextareaFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class TextareaFieldRenderer extends BaseFieldRenderer<TextareaFieldJsonData> {
    protected override get defaultData(): TextareaFieldJsonData {
        return {
            id: '',
            type: 'textarea',
            label: TranslateUtils.TEXTAREA_FIELD.LABEL,
            placeholder: TranslateUtils.TEXTAREA_FIELD.PLACEHOLDER,
            description: '',
            required: false,
            hiddenLabel: false
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: TextareaFieldJsonData, options: RenderOptions): HTMLElement {
        const textarea = document.createElement('textarea');
        textarea.classList.add('textarea', 'input');
        textarea.maxLength = 65535;

        this.applyCommonAttributes(textarea, fieldJsonData);

        if (fieldJsonData.height) {
            textarea.style.height = `${fieldJsonData.height}px`;
        }

        return textarea;
    }
}
